import React, { Fragment, useMemo } from "react";
import classNames from "classnames";
import useLayerSorting from "./useLayerSorting";
import Form from "theme/components/atoms/Form/Form";
import Select from "theme/components/atoms/Form/Input/Select";

import FormItem from "theme/components/molecules/Form/Item";
import { defineMessages, useIntl } from "react-intl";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary/ErrorBoundary";

const messages = defineMessages({
  sortLabel: {
    id: "modules.Layer.LayerSorting.sortLabel",
    defaultMessage: "Sort:",
  },
});

const LayerSorting = ({ appearance, value }) => {
  const intl = useIntl();

  const [{ pageLengthOptions, sortOptions }, currentValue, sortAction] =
    useLayerSorting(value);

  const Wrapper = useMemo(() => {
    if (appearance === "standalone") {
      return ({ children }) => <Form onChange={sortAction}>{children}</Form>;
    } else {
      return Fragment;
    }
  }, [appearance, sortAction]);

  return (
    <Wrapper>
      <div
        className={classNames("layer-sorting", {
          [`layer-sorting--${appearance}`]: appearance,
        })}
      >
        <div className="layer-sorting__element">
          {pageLengthOptions.length > 1 ? (
            <FormItem label="Show products" appearance="inline">
              <Select
                id="pageLength"
                name="pageLength"
                options={pageLengthOptions}
                value={currentValue.pageLength}
              />
            </FormItem>
          ) : undefined}
        </div>
        <div className="layer-sorting__element">
          <FormItem
            label={intl.formatMessage(messages.sortLabel)}
            appearance="inline"
          >
            <Select
              id="sort"
              name="sort"
              options={sortOptions}
              value={currentValue.sort}
            />
          </FormItem>
        </div>
      </div>
    </Wrapper>
  );
};

export default withHideOnErrorBoundary(LayerSorting);
